import { useEpisodeDetailPageController } from '@controllers/useEpisodeDetailPageController';
import EpisodeDetailPageView from '@views/pages/EpisodeDetailPageView';

export default function EpisodeDetailPage() {
  return <EpisodeDetailPageView {...useEpisodeDetailPageController()} />;
}
